import { app } from "./app/index.js";

app.$mount("#app");
